import { useMeControlScript } from './builder';
import { useMeControlCommandListEffect, useMeControlAccountEffect, } from './useMeControlCommandListEffect';
import { useMeControlConfigEffect } from './useMeControlConfigEffect';
/**
 * Separate component for handling mounting and clearing of the
 * Microsoft MeControl for user signin/signout.
 */
export const MeControlScript = ({ meControlCommandList = [], }) => {
    //note: returning ready here allows us to trigger a rerender once we finish downloading MC scripts
    const { ready } = useMeControlScript();
    useMeControlConfigEffect(ready);
    //load these in when they change
    useMeControlCommandListEffect(meControlCommandList);
    useMeControlAccountEffect();
    return null;
};
